const specificDropdown = {
    name: document.getElementById('jsOpenVariation') as HTMLElement , 
    wrapper: document.getElementById('jsVariationWrapper') as HTMLElement ,
    childProds: document.getElementById('jsStock') as HTMLElement, 
    childProdsWrap: document.getElementById('jsStockWrap') as HTMLElement,

    init(){
        this.setDropdown();
        this.setTarget();
        this.closeDropdown();
        // this.setChildProds();
 
    },




    setChildProds() {
          this.childProdsWrap.innerHTML += this.childProds.innerHTML;

    },


    setTarget() {
        window.addEventListener('click', (e) => {
             const target = e.target as HTMLElement; 

             if(target !== this.name && !this.name.contains(target) && target !== this.wrapper && !this.wrapper.contains(target)) {
                this.wrapper.classList.remove('activeClass');
                this.name.classList.remove('activeClass');
             }
        })
    },


    closeDropdown() {
        this.wrapper.addEventListener('click', () => {
               this.wrapper.classList.remove('activeClass');
               this.name.classList.remove('activeClass');
        })
    },


    setDropdown(){
       this.name.addEventListener('click', () => {
            this.wrapper.classList.toggle('activeClass');
            this.name.classList.toggle('activeClass');
       })
    }

}

export default specificDropdown